import {
  faPlus,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  setSelectedAppClient,
  resetAppClientMapping,
} from "../../state/appClientMappingSlice"
import { useNavigate } from "react-router-dom"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components" 
import { useDelete, useFetchWithBody } from "../../api/reactQueryCustomHooks"
import { ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"

function AppClientMapping() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { selectedClient } = useSelector((state) => state.clientMaster)

  /*  */
  const exportColumns = [
    { uid: "Client_Code", name: "Client Code" },
    { uid: "Client_Name", name: "Client Name" },
    { uid: "AppId", name: "App Id" },
    { uid: "AppName", name: "App Name" },
  ]

  /*  */
  const onClickEdit = (item) => {
    dispatch(setSelectedAppClient(item))
    navigate(linksUrl.appClientMapping.edit)
  }

  const onClickDelete = (item) => {
    deleteAppClientMapping({
      data: {
        id: item.Id,
        appId: item.AppId,
        client_code: item.Client_Code,
      },
    })
  }

  const { mutate: deleteAppClientMapping } = useDelete({
    url: apiRoute.appClientMapping.delete,
    queryKey: "AppClientMapping",
  })

  const onClickPrevPage = () => {
    dispatch(resetAppClientMapping())
    navigate(linksUrl.clientMaster.read)
  }

  const {
    isLoading,
    isError,
    data = [],
  } = useFetchWithBody({
    url: apiRoute.appClientMapping.read,
    queryKey: "AppClientMapping",
    inputData: {
      client_code: selectedClient.client_code,
      appId: null,
      option: 1,
    },
  })

  const columns = [
    { uid: "AppName", name: "App Name" },
    {
      name: "ACTIONS",
      uid: "actions",
    },
  ]

  const INITIAL_VISIBLE_COLUMNS = ["AppName", "actions"]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        navigate(linksUrl.appClientMapping.add)
      },
      label: "Add Client App", 
    },
  ]

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: onClickEdit,
      label: "Edit",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faTrash} />,
      onClick: onClickDelete,
      label: "Delete",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]
 

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName="Client App Mapping"
        breadcrumbs={["Client Master", "App"]}
        info={[
          ["Client", selectedClient.client_name, selectedClient.client_code],
        ]}
        prevPage={{
          show: true,
          onClick: onClickPrevPage,
        }}
      >
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}
          rowActionBtn={rowActionBtn}
          
          downloadFileName="Client_App_Mapping"
          id="AppId"
        />
      </MainContainer>
    </div>
  )
}

export default AppClientMapping
